import { Link, Paragraph } from '@vimeo/iris/typography';

export default function AuthenticationExtras() {
  return (
    <div>
      <Paragraph size="2">
        For more information about authentication workflows, see our{' '}
        <Link variant="minimal" href="https://developer.vimeo.com/api/authentication">
          Working with Authentication
        </Link>{' '}
        guide.
      </Paragraph>

      <Paragraph size="2">Use the API to complete the following tasks:</Paragraph>
    </div>
  );
}
